import { Link } from 'react-router-dom';

interface FooterProps {
  currentLanguage: string;
}

export default function Footer({ currentLanguage }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-8 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {currentLanguage === 'en' ? 'About RMC' : 'RMC గురించి'}
            </h3>
            <p className="text-gray-300 text-sm mb-4">
              {currentLanguage === 'en' 
                ? 'Rajahmundry Municipal Corporation is committed to providing efficient civic services and improving the quality of life for all citizens.'
                : 'రాజమండ్రి మునిసిపల్ కార్పొరేషన్ అన్ని పౌరులకు సమర్థవంతమైన పౌర సేవలను అందించడానికి మరియు జీవన నాణ్యతను మెరుగుపరచడానికి కట్టుబడి ఉంది.'
              }
            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/officeRMC/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://x.com/RMCoffice" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="https://api.whatsapp.com/send/?phone=9494060060&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-whatsapp-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com/rmcoffice/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {currentLanguage === 'en' ? 'Quick Links' : 'త్వరిత లింకులు'}
            </h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="https://rajahmundry.emunicipal.ap.gov.in/ptis/citizen/search/search-searchForm.action#no-back-button" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'Property Tax' : 'ఆస్తి పన్ను'}</Link></li>
              <li><Link to="https://rajahmundry.emunicipal.ap.gov.in/wtms/search/waterSearch/" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'Water Tax' : 'నీటి పన్ను'}</Link></li>
              <li><Link to="https://dc.crsorgi.gov.in/crs/web/index.php/auth/login" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'Birth & Death Registration' : 'జనన మరణ నమోదు'}</Link></li>
              <li><Link to="https://rajahmundry.emunicipal.ap.gov.in/tl/newtradelicense/newTradeLicense-newForm.action#no-back" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'Trade License' : 'వాణిజ్య లైసెన్స్'}</Link></li>
              {/* <li><Link to="/grievances" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'File Grievance' : 'ఫిర్యాదు దాఖలు చేయండి'}</Link></li> */}
            </ul>
          </div>

          {/* Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {currentLanguage === 'en' ? 'Information' : 'సమాచారం'}
            </h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/resources/tenders" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'Tenders' : 'టెండర్లు'}</Link></li>
              {/* <li><Link to="/notifications" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'Notifications' : 'నోటిఫికేషన్లు'}</Link></li> */}
              {/* <li><Link to="/downloads" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'Downloads' : 'డౌన్‌లోడ్‌లు'}</Link></li> */}
              {/* <li><Link to="/rti" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'RTI' : 'RTI'}</Link></li> */}
              <li><Link to="/gis-map" className="text-gray-300 hover:text-white cursor-pointer">{currentLanguage === 'en' ? 'Site Map' : 'సైట్ మ్యాప్'}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              {currentLanguage === 'en' ? 'Contact Information' : 'సంప్రదింపు సమాచారం'}
            </h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-blue-400 mt-1"></i>
                <a
                  href="https://www.google.com/maps?q=17.008681,81.769588&z=16"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-blue-300 transition-colors"
                >
                  {currentLanguage === 'en'
                    ? 'Municipal Corporation Rajamahendravaram MCR, Near Gokavaram Bus Stand, Sheshyametta, Rajamahendravaram.'
                    : 'మునిసిపల్ కార్పొరేషన్ రాజమహేంద్రవరం MCR, గోకవరం బస్ స్టాండ్ సమీపంలో, శేషయ్యమెట్ట, రాజమహేంద్రవరం.'
                  }
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-blue-400"></i>
                <a
                  href="tel:9494060060"
                  className="text-gray-300 hover:text-blue-300 transition-colors"
                >
                  9494 060 060
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-blue-400"></i>
                <a
                  href="mailto:comm_mcr@yahoo.co.in"
                  className="text-gray-300 hover:text-blue-300 transition-colors break-all"
                >
                  comm_mcr@yahoo.co.in
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-time-line text-blue-400"></i>
                <span className="text-gray-300">
                  {currentLanguage === 'en' ? 'Mon-Fri: 10:00 AM - 5:00 PM' : 'సోమ-శుక్ర: 10:00 AM - 5:00 PM'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-400 mb-4 md:mb-0">
              © 2024 Rajahmundry Municipal Corporation. {currentLanguage === 'en' ? 'All rights reserved.' : 'అన్ని హక్కులు రక్షించబడ్డాయి.'}
            </div>
            <div className="flex flex-wrap items-center gap-4 sm:gap-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-white cursor-pointer">
                {currentLanguage === 'en' ? 'Privacy Policy' : 'గోప్యతా విధానం'}
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white cursor-pointer">
                {currentLanguage === 'en' ? 'Terms of Use' : 'వినియోగ నిబంధనలు'}
              </Link>
              <Link to="/feedback" className="text-gray-400 hover:text-white cursor-pointer">
                {currentLanguage === 'en' ? 'Feedback' : 'అభిప్రాయం'}
              </Link>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
